(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["my-complete-setup"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSizeSelect(select) {
    var wrap = select.closest('.pm-set__size');
    if (!wrap) return;
    var label = wrap.querySelector('.pm-set__size-label');
    var defaultText = label ? label.textContent : '';
    select.addEventListener('change', function () {
      var card = select.closest('.pm-set__card');
      if (card) card.setAttribute('data-variant-id', select.value || '');
      if (!label) return;
      var opt = select.options[select.selectedIndex];
      label.textContent = select.value && opt ? opt.textContent : defaultText;
    });
  }
  var selects = document.querySelectorAll('.pm-set__select');
  for (var i = 0; i < selects.length; i++) {
    initSizeSelect(selects[i]);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-influencer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function step(track) {
    var card = track.querySelector('.pm-rev__card');
    if (!card) return track.clientWidth;
    var style = getComputedStyle(track);
    var gap = parseFloat(style.columnGap || style.gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function init(root) {
    var track = root.querySelector('[data-pm-rev-track]');
    if (!track || track.dataset.bound) return;
    track.dataset.bound = 'true';

    var next = root.querySelector('[data-pm-rev-next]');
    if (!next) return;

    next.addEventListener('click', function () {
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 0) return;
      if (track.scrollLeft >= max - 4) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: step(track), behavior: 'smooth' });
      }
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.pm-rev').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-looks-by"] && !Shopify.designMode) return;
  try {
    
(function () {
  function update(track, bar, thumb) {
    var max = track.scrollWidth - track.clientWidth;
    if (max <= 1) {
      bar.style.opacity = '0';
      return;
    }
    bar.style.opacity = '1';
    var width = Math.max((track.clientWidth / track.scrollWidth) * 100, 12);
    var progress = track.scrollLeft / max;
    thumb.style.width = width + '%';
    thumb.style.left = progress * (100 - width) + '%';
  }

  function init(root) {
    var track = root.querySelector('[data-shop-looks-track]');
    var bar = root.querySelector('[data-shop-looks-bar]');
    var thumb = root.querySelector('[data-shop-looks-thumb]');
    if (!track || !bar || !thumb || track.dataset.bound) return;
    track.dataset.bound = 'true';

    var frame;
    var onScroll = function () {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = null;
        update(track, bar, thumb);
      });
    };

    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update(track, bar, thumb);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.shop-looks').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
